import { Component, Host, h, Prop, Event, EventEmitter } from '@stencil/core';
import { addClass } from '../../utils/helpers/helpers';

@Component({
  tag: 'lgr-accordion',
  styleUrl: 'accordion.scss',
  shadow: true,
})
export class Accordion {
  /**
   * closed gray.
   */
  @Prop({ reflect: true }) closedGray: boolean = false;
  /**
   * disabled state.
   */
  @Prop({ reflect: true }) disabled: boolean = false;
  /**
   * variant: inverse or not.
   */
  @Prop({ reflect: true }) inverse: boolean = false;
  /**
   * The heading of the accordion.
   */
  @Prop({ reflect: true }) heading?: string;
  /**
   * Indicates whether the accordion content is shown or not.
   */
  @Prop({ reflect: true, mutable: true }) isOpen: boolean = false;
  /**
   * Event emitted on button click.
   */
  @Event({ composed: true, cancelable: true, bubbles: true }) lgrAccordionClick!: EventEmitter<boolean>;

  render() {
    const classList = [this.inverse ? 'inverse' : null, this.disabled ? 'disabled' : null, this.isOpen ? 'lgr-open-accordion' : 'lgr-closed-accordion', this.closedGray ? 'closed-gray' : null];

    return (
      <Host style={{ pointerEvents: this.disabled ? 'none' : undefined }} aria-disabled={this.disabled ? 'true' : null} aria-expanded={this.isOpen}>
        <button disabled={this.disabled} aria-disabled={this.disabled} aria-expanded={this.isOpen} class={`${addClass(classList)}`} onClick={this.handleClick}>
          <h2>{this.heading}</h2>
          <div class={`${addClass(['lgr-accordion-expand-icon', ...classList])}`}>
          <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.88 -2.53231e-06L1.41575e-06 1.90283L8 10L16 1.90283L14.12 -3.92204e-07L8 6.18084L1.88 -2.53231e-06Z" fill="#183C8F"/>
          </svg>

            <span>expand_more</span>
          </div>
        </button>
        <div class={`${addClass(['lgr-accordion-content', ...classList])}`}>
          <slot></slot>
        </div>
      </Host>
    );
  }

  private handleClick = () => {
    this.isOpen = !this.isOpen;
    this.lgrAccordionClick.emit(this.isOpen);
  };
}
